import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./App.css";

import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";
import Home from "./components/Home.js";
import CounterPage from "./projects/counter-app/CounterPage.js";
import ErrorPage from "./components/ErrorPage.js";
import TodoPage from "./projects/todo-app/TodoPage.js";
import Navbar from "./components/Navbar.js";
import LearnBasicReactPage from "./pages/BasicsPage.js";
import IntermediatePage from "./pages/IntermediatePage.js";
import AdvancedPage from "./pages/AdvancedPage.js";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <Navbar /> {/* Add the Navbar component */}
        <App />
      </>
    ),
  },
  {
    path: "/basic",
    element: (
      <>
        <Navbar /> {/* Add the Navbar component */}
        <LearnBasicReactPage />
      </>
    ),
  },
  {
    path: "/intermediate",
    element: (
      <>
        <Navbar /> {/* Add the Navbar component */}
        <IntermediatePage />
      </>
    ),
  },
  {
    path: "/advanced",
    element: (
      <>
        <Navbar /> {/* Add the Navbar component */}
        <AdvancedPage />
      </>
    ),
  },
  {
    path: "/counter",
    element: (
      <>
        <Navbar /> {/* Add the Navbar component */}
        <CounterPage />
      </>
    ),
  },
  {
    path: "/todo-app",
    element: (
      <>
        <Navbar /> {/* Add the Navbar component */}
        <TodoPage />
      </>
    ),
  },
  {
    path: "*",
    element: (
      <>
        {/* <Navbar /> Add the Navbar component */}
        <ErrorPage />
      </>
    ),
  },
]);
ReactDOM.createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);
